import { render, staticRenderFns } from "./systemnew.vue?vue&type=template&id=04d17c1c&scoped=true&"
import script from "./systemnew.vue?vue&type=script&lang=js&"
export * from "./systemnew.vue?vue&type=script&lang=js&"
import style0 from "./systemnew.vue?vue&type=style&index=0&id=04d17c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d17c1c",
  null
  
)

export default component.exports